"use strict";

function main() {
  $(".Header-mobile-menu").click(function () {
    if (!$(".Header-mobile-menu").hasClass("active")) {
      $(this).addClass("active");
      $(".Header-menu").addClass("active");
      $("body").addClass("fixed");
    } else {
      $(this).removeClass("active");
      $(".Header-menu").removeClass("active");
      $("body").removeClass("fixed");
    }
  });

  var slider = new Swiper(".slider .swiper-container", {
    loop: true,
    fadeEffect: {
      crossFade: true,
    },
    parallax: true,
    pagination: {
      el: ".pagination",
      type: "bullets",
      bulletActiveClass: "active",
      bulletClass: "bullet",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"><i></i></span>';
      },
    },
  });

  var galleryThumbs = new Swiper(".gallery-thumbs", {
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  var galleryTop = new Swiper(".gallery-top", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });
  var boxSlider = new Swiper(".box-slider", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  let title = $(".title h1").text();
  let titleArr = title.trim().split("");
  $(".title h1").html("");
  titleArr.forEach(function (e, i) {
    if (i == 0) {
      $(".title h1").append("<span>" + e + "</span>");
    } else {
      $(".title h1").append(e);
    }
  });
}

// Document.Ready
document.addEventListener("DOMContentLoaded", function () {
  main();
});
